// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import xProductPartNumbersStyles from "@guestsupply/App/SharedStyles/ProductPartNumbersStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { rfqQuoteDetailsSalesRepProductListStyles } from "@guestsupply/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { hideElement, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsSalesRepProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqQuoteDetailsSalesRepProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

rfqQuoteDetailsSalesRepProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingStyles = {
    row: {
        mergeCss: true,
        evenRowCss: css`
            background: transparent;
        `,
        css: css`
            border: none;
        `,
    },
    quantityCell: {
        css: css`
            border: none;
            height: 18px;
            vertical-align: top;
            padding: 0 8px 0 0;
            display: flex;
            align-items: baseline;
        `,
    },
    priceCell: {
        css: css`
            border: none;
            height: 18px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    priceWithoutVatCell: {
        css: css`
            border: none;
            height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.uomHeadingAndText = {
    heading: {
        weight: "bold",
        size: 12,
        css: css`
            ${hideElement}
        `,
    },
    text: {
        css: css`
            padding-left: 6px;
            white-space: nowrap;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingContainer = {
    css: css`
        display: flex;
        align-items: flex-start;
        padding-top: 3px;
        > div {
            display: inline-block;
            width: auto;
        }
        > div:first-child {
            max-width: 140px;
        }

        ${xScreen("lte", "md")} {
            > div:first-child {
                max-width: 100%;
            }
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.qtyOrderedField = {
    container: {
        css: css`
            padding-top: 3px;
        `,
    },
    valueText: {
        css: css`
            line-height: 24px;
            ${xScreen("lte", "md")} {
                line-height: 17px;
            }
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.buttonContainer = {
    css: css`
        display: flex;
        justify-content: flex-end;
        button {
            min-height: 32px;
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.isEditableCartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 91px 2.5fr 1.5fr 1fr 100px;
        `,
    },
    total: {
        css: css`
            ${xScreen("lte", "md")} {
                justify-content: flex-end;
            }
        `,
    },
    remove: {
        css: css`
            &:empty {
                display: none;
            }
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.isEditableLinesHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 91px 2.5fr 1.5fr 1fr 100px;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 91px 3fr 1.5fr 1fr;
        `,
    },
    remove: {
        css: css`
            &:empty {
                display: none;
            }
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.linesHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 91px 3fr 1.5fr 1fr;
        `,
    },
    qty: {
        css: css`
            border-right: 0;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quoteCalculationModal = {
    sizeVariant: "medium",
};

rfqQuoteDetailsSalesRepProductListStyles.labelValueStyles = {
    ...createHorizontalSmallHeadingAndTextStyles({
        heading: {
            ...xProductPartNumbersStyles.label,
        },
        text: {
            ...xProductPartNumbersStyles.value,
        },
    }),
};

rfqQuoteDetailsSalesRepProductListStyles.headerWrapper = {
    css: css`
        padding-bottom: 15px;
    `,
};
